/* ==========================================================================
   nl-marquee.js — one shared marquee behavior for every mt- section.
   Seamless horizontal auto-scroll driven by the Web Animations API (self-
   contained — no per-section @keyframes to coordinate). Clones the track
   content enough to fill 2× the viewport so the loop is gapless.

   Root: [data-nl-marquee]  value = scroll speed in px/sec (default 60)
   Track: [data-nl-marquee-track]  (holds the items once; JS duplicates)

   Pauses on hover/focus. Respects prefers-reduced-motion (no animation — the
   row stays static and horizontally scrollable via the section's CSS).
   Editor lifecycle: guards double-init, re-inits on shopify:section:load,
   cancels the animation on shopify:section:unload.
   ========================================================================== */
(function () {
  'use strict';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var instances = [];

  function Marquee(root) {
    this.root = root;
    this.track = root.querySelector('[data-nl-marquee-track]');
    this.speed = parseFloat(root.getAttribute('data-nl-marquee')) || 60;
    this.anim = null;
    this._bound = [];
    if (this.track && this.track.children.length) this.init();
  }

  Marquee.prototype.on = function (el, ev, fn) {
    el.addEventListener(ev, fn); this._bound.push([el, ev, fn]);
  };

  Marquee.prototype.init = function () {
    var self = this;
    // Snapshot the original set, then clone whole sets until we cover 2× viewport.
    this.originals = Array.prototype.slice.call(this.track.children);
    var oneSetWidth = this.track.scrollWidth;
    if (oneSetWidth <= 0) return;
    var target = this.root.offsetWidth * 2 + oneSetWidth;
    var guard = 0;
    while (this.track.scrollWidth < target && guard < 20) {
      this.originals.forEach(function (node) {
        var c = node.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        self.track.appendChild(c);
      });
      guard++;
    }
    this._oneSetWidth = oneSetWidth;

    if (REDUCE) return; // static, scrollable — no animation

    var duration = (oneSetWidth / this.speed) * 1000;
    this.anim = this.track.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + oneSetWidth + 'px)' }],
      { duration: duration, iterations: Infinity, easing: 'linear' }
    );

    this.on(this.root, 'mouseenter', function () { if (self.anim) self.anim.pause(); });
    this.on(this.root, 'mouseleave', function () { if (self.anim) self.anim.play(); });
    this.on(this.root, 'focusin', function () { if (self.anim) self.anim.pause(); });
    this.on(this.root, 'focusout', function () { if (self.anim) self.anim.play(); });
  };

  Marquee.prototype.destroy = function () {
    if (this.anim) { this.anim.cancel(); this.anim = null; }
    this._bound.forEach(function (b) { b[0].removeEventListener(b[1], b[2]); });
    this._bound = [];
    this.root.__mtMarquee = null;
  };

  function initWithin(scope) {
    var roots = (scope || document).querySelectorAll('[data-nl-marquee]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__mtMarquee) return;
      root.__mtMarquee = new Marquee(root);
      instances.push(root.__mtMarquee);
    });
  }
  function destroyWithin(scope) {
    var roots = (scope || document).querySelectorAll('[data-nl-marquee]');
    Array.prototype.forEach.call(roots, function (root) { if (root.__mtMarquee) root.__mtMarquee.destroy(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
  else initWithin(document);
  document.addEventListener('shopify:section:load', function (e) { initWithin(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyWithin(e.target); });
})();
